import { DjangoWaffleType } from "@shared/contexts/WaffleContext/django-waffle-type";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyArgs = any[];

interface LegacyWidgetEntry {
  oldPath: (...args: AnyArgs) => string;
  nextjsPath?: (...args: AnyArgs) => string;
  flag: keyof DjangoWaffleType["FLAGS"];
}

interface NewWidgetEntry {
  nextjsPath: (...args: AnyArgs) => string;
}

export type URLMapEntry = LegacyWidgetEntry | NewWidgetEntry;

export const URL_MAP: Record<string, URLMapEntry> = {
  login: {
    oldPath: () => "/w/tickets/events/login/",
    nextjsPath: () => "/accounts/login/",
    flag: "sdk_use_nextjs_login_widget",
  },
  checkout: {
    oldPath: () => "/w/tickets/events/checkout/",
    flag: "sdk_use_nextjs_checkout_widget",
  },
  eventPurchase: {
    oldPath: (slug: string) => `/w/tickets/events/purchase/${slug}/`,
    flag: "sdk_use_nextjs_event_purchase_widget",
  },
  expressCheckout: {
    oldPath: () => "/w/tickets/events/express-checkout/",
    flag: "sdk_use_nextjs_express_checkout_widget",
  },
  productPurchase: {
    oldPath: (id: string) => `/w/tickets/products/purchase/${id}/`,
    flag: "sdk_use_nextjs_product_purchase_widget",
  },
  calendar: {
    oldPath: (id: string, isAttraction: boolean) =>
      isAttraction
        ? `/widget/tickets/events/calendar/${id}/`
        : `/w/tickets/events/calendar/${id}/`,
    nextjsPath: (id: string) => `/widget/tickets/events/calendar/${id}/`,
    flag: "sdk_use_nextjs_calendar_widget",
  },
  basket: {
    oldPath: () => "/w/tickets/events/cart/",
    flag: "sdk_use_nextjs_basket_widget",
  },
  membership: {
    nextjsPath: (id: string) => `/widget/tickets/memberships/${id}/`,
  },
};
